import { render, staticRenderFns } from "./recommendation.vue?vue&type=template&id=22e0859c&scoped=true&"
import script from "./recommendation.vue?vue&type=script&lang=js&"
export * from "./recommendation.vue?vue&type=script&lang=js&"
import style0 from "./recommendation.vue?vue&type=style&index=0&id=22e0859c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0859c",
  null
  
)

export default component.exports